import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Transform } from 'class-transformer';
import { isBoolean, IsBoolean, isBooleanString, isNumberString, IsOptional } from 'class-validator';

import { FIELD_INVALID_VALUE } from '../constants';
import { BaseDecoratorOptions } from '../types';

export function ApiPropertyBoolean({ isOptional, ...options }: BaseDecoratorOptions<boolean> = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = { type: Boolean, example: true, ...options };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsBoolean({ message: FIELD_INVALID_VALUE }),
    Transform(({ value }) =>
      !isNumberString(value) && (isBooleanString(value) || isBoolean(value))
        ? value === 'true' || value === true
        : value,
    ),
  );
}
